/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Severity level for findings produced by this rule.
 */
export const Severity = {
  Info: "info",
  Low: "low",
  Medium: "medium",
  High: "high",
  Critical: "critical",
} as const;
/**
 * Severity level for findings produced by this rule.
 */
export type Severity = ClosedEnum<typeof Severity>;

export type CreateCustomDetectionRuleRequestBody = {
  /**
   * Description of what the rule detects.
   */
  description?: string | undefined;
  /**
   * CEL detection predicate: a boolean expression over message fields whose true verdict produces a finding.
   */
  detectionExpr?: string | undefined;
  /**
   * Deprecated legacy RE2 regex pattern; superseded by detection_expr. Accepted for backward compatibility.
   */
  regex?: string | undefined;
  /**
   * Stable rule identifier, prefixed with `custom.`.
   */
  ruleId: string;
  /**
   * Severity level for findings produced by this rule.
   */
  severity?: Severity | undefined;
  /**
   * Human-readable title for the rule.
   */
  title: string;
};

/** @internal */
export const Severity$outboundSchema: z.ZodMiniEnum<typeof Severity> = z.enum(
  Severity,
);

/** @internal */
export type CreateCustomDetectionRuleRequestBody$Outbound = {
  description?: string | undefined;
  detection_expr?: string | undefined;
  regex?: string | undefined;
  rule_id: string;
  severity: string;
  title: string;
};

/** @internal */
export const CreateCustomDetectionRuleRequestBody$outboundSchema: z.ZodMiniType<
  CreateCustomDetectionRuleRequestBody$Outbound,
  CreateCustomDetectionRuleRequestBody
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    detectionExpr: z.optional(z.string()),
    regex: z.optional(z.string()),
    ruleId: z.string(),
    severity: z._default(Severity$outboundSchema, "medium"),
    title: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      detectionExpr: "detection_expr",
      ruleId: "rule_id",
    });
  }),
);

export function createCustomDetectionRuleRequestBodyToJSON(
  createCustomDetectionRuleRequestBody: CreateCustomDetectionRuleRequestBody,
): string {
  return JSON.stringify(
    CreateCustomDetectionRuleRequestBody$outboundSchema.parse(
      createCustomDetectionRuleRequestBody,
    ),
  );
}
